module.exports = ['$scope', '$location', ($scope, $location) ->

  $scope.goToPage = (newPage) =>
    $location.replace().search _.merge($location.search(), { page: newPage })
]
